module.exports = __webpack_public_path__ + "static/img/rank_320.ac35781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_320.png
// module id = LzJe
// module chunks = 0